import script from "./PlayerList.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlayerList.vue?vue&type=script&setup=true&lang=ts"

import "./PlayerList.vue?vue&type=style&index=0&id=6f002f38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f002f38"]])

export default __exports__